<template>
  <div class="content-container">
    <search-comp
      @onSearch="attachData"
      @onReset="
        () => {
          searchParams.isActive = 2
          attachData()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.isActive"
                  placeholder="Vui lòng chọn"
                  @change="attachData"
                >
                  <el-option label="Tất cả" :value="2"> </el-option>
                  <el-option label="Đang hoạt động" :value="1"> </el-option>
                  <el-option label="Không hoạt động" :value="0"> </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        dom-layout="scroll"
        class="agGrid"
        :row-multi-select-with-click="true"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteSource"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="!isEdit ? 'Thêm nguồn' : 'Sửa nguồn'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã nguồn</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã nguồn"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider
                    rules="required|max:100"
                    name="Mô tả nguồn"
                  >
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Nhóm nguồn</div>
                  <validation-provider rules="required" name="Nhóm nguồn">
                    <select-with-search-table
                      style="width: 100%"
                      :rows="sourceGroupOptions"
                      :columns="columnsGroup"
                      :value="form.p_id"
                      :selected-index-field-value="form.p_id"
                      index-field="id"
                      @selectionChanged="onSelectRowOption"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.code }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Nhân viên kinh doanh theo chuỗi</div>
                  <validation-provider
                    rules=""
                    name="Nhân viên kinh doanh theo chuỗi"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="businessManRows"
                      :search-fields="['id', 'full_name']"
                      :columns="businessManCols"
                      :value="form.business_man_id"
                      :selected-index-field-value="form.business_man_id"
                      index-field="id"
                      :dropdown-width="400"
                      :is-remove-btn="true"
                      @selectionChanged="onSelectBusinessMan"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.full_name }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label" style="margin-right: 10px">Hoạt động</div>

                  <el-switch
                    v-model="form.active"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateSource"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small outline" @click="addSource">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getSourceGroupApi } from '@/api/Statistics/sourceGroup'
import {
  getSourceApi,
  updateSourceApi,
  addSourceApi,
  deleteSourceApi,
  getAllBusinessMan
} from '@/api/Statistics/source'
import { Message } from 'element-ui'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderToggleSwitchReadOnly,
    SelectWithSearchTable
  },
  data() {
    return {
      isDisableModify: false,
      isDisableDelete: false,
      loading: false,
      defaultForm: {
        code: '',
        desc: '',
        id: null,
        order: 0,
        active: true,
        business_man_id: null,
        p_id: null
      },
      form: {
        code: '',
        desc: '',
        id: null,
        business_man_id: null,
        order: 0,
        active: true,
        p_id: null
      },

      titlePopup: 'Thêm nguồn',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        isActive: 2
      },
      sourceGroupOptions: [],
      columnsGroup: [
        {
          headerName: 'Mã nhóm',
          field: 'code',
          minWidth: 150,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          flex: 1,
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      businessManRows: [],
      businessManCols: [
        {
          headerName: this.$t('config.profile.select.businessManCode'),
          field: 'id',
          tooltipField: 'id'
        },
        {
          headerName: this.$t('config.profile.select.businessManName'),
          field: 'full_name',
          tooltipField: 'full_name'
        }
      ],

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã nguồn',
          field: 'code',
          sortable: false,
          width: 100,
          minWidth: 100
        },
        {
          headerName: 'Mô tả',
          sortable: false,
          field: 'desc'
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Nhóm nguồn',
          sortable: false,
          field: 'p_code',
          minWidth: 100
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Nhân viên kinh doanh theo chuỗi',
          sortable: false,
          field: 'business_man_nm',
          minWidth: 200

          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Hoạt động',
          sortable: false,
          field: 'active',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.active
            }
          }
        }
      ],

      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  },
  beforeMount() {
    this.getSourceGroup()
  },

  async mounted() {
    this.businessManRows = await getAllBusinessMan()
    this.attachData()
  },
  methods: {
    onSelectRowOption(val) {
      this.form.p_id = val.id
    },
    onSelectBusinessMan(val) {
      this.form.business_man_id = val?.id || null
    },

    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    async getSourceGroup() {
      let data = await getSourceGroupApi({ isActive: 1 })
      this.sourceGroupOptions = data.data
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },

    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loading = true
      let data = await getSourceApi(this.searchParams)
      // bus.$emit("endLoader");
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addSource() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      let data = await addSourceApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateSource() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateSourceApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteSource() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteSourceConfirm'), () => {
          deleteSourceApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              // if (this.isActive) {
              //   this.attachData({ isActive: 0 })
              // } else {
              //   this.attachData({ isActive: 1 })
              // }
              this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.isEdit = false
      this.dialogFormVisible = true
    },

    updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        console.log(rowsSelected)
        this.titlePopup = 'Sửa nguồn'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form.order = rowData.order
        this.form.id = rowData.id
        this.form.p_id = rowData.p_id
        this.form.code = rowData.code
        this.form.desc = rowData.desc
        this.form.business_man_id = rowData.business_man_id
        this.form.active = rowData.active
        this.dialogFormVisible = true
      }
    },

    resetItemInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
